import React from 'react';
import { ArrowRight, Download, Linkedin } from 'lucide-react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section id="home" className="pt-[200px] pb-[100px] w-full bg-dark text-white/65 text-base leading-[30px] font-inter overflow-hidden" data-id="element-89">
      <div className="max-w-[1320px] mx-auto px-[15px]" data-id="element-90">
        <div className="flex flex-wrap items-center -mx-[15px]" data-id="element-91">
          <div className="shrink-0 w-full max-w-full px-[15px]" data-id="element-92">
            {/* Hero Content */}
            <div className="text-center relative px-4 md:px-[250px] mb-[60px]" data-id="element-93">
              <motion.h2 initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5
            }} className="font-normal leading-6 text-white/[0.69] text-xl font-syne mb-[5px]" data-id="element-94">
                Hi! 👋 My name is Sage Stephens
              </motion.h2>
              <motion.h1 initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.1
            }} className="font-bold leading-tight md:leading-[95px] text-white text-5xl md:text-[90px] font-syne mb-[25px]" data-id="element-95">
                Web Developer &{' '}
                <span className="text-gold relative inline-block" data-id="element-96">
                  UX
                  {/* Underline decoration */}
                  <svg className="absolute w-full h-3 -bottom-1 left-0 text-gold" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-97">
                    <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="2" fill="none" data-id="element-98" />
                  </svg>
                </span>{' '}
                Specialist
              </motion.h1>

              {/* Decorative Shape - Left */}
              <div className="absolute left-[10%] top-[20%] animate-rotate-circle hidden lg:block opacity-60" data-id="element-99">
                <div className="w-12 h-12 border-2 border-dashed border-white/20 rounded-full" data-id="element-100"></div>
              </div>

              {/* Decorative Shape - Right */}
              <div className="absolute right-[10%] top-[40%] animate-rotate-circle hidden lg:block opacity-60" data-id="element-101">
                <div className="w-8 h-8 bg-gold/20 rounded-full" data-id="element-102"></div>
              </div>

              {/* CTA Button */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} className="flex flex-wrap items-center justify-center gap-4 mt-[15px]" data-id="element-103">
                <a href="#contact" className="inline-flex items-center justify-center text-lg font-semibold leading-5 border rounded px-10 py-[15px] transition-all duration-300 cursor-pointer font-inter whitespace-nowrap bg-gold text-true-white border-black shadow-[4px_4px_0px_0px_#fff,4px_4px_0px_1px_#000] hover:-translate-y-1 hover:shadow-[6px_6px_0px_0px_#fff,6px_6px_0px_1px_#000]" data-id="element-104">
                  Hire Me{' '}
                  <ArrowRight className="inline-block w-[18px] h-[18px] align-middle ml-2" data-id="element-105" />
                </a>

                {/* ⬇️ Replace the href below with your actual CV file URL */}

                <a href="https://www.linkedin.com/in/sageartitstudio/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center text-lg font-semibold leading-5 border rounded px-10 py-[15px] transition-all duration-300 cursor-pointer font-inter whitespace-nowrap bg-transparent text-white border-white hover:bg-white hover:text-black hover:border-black shadow-[4px_4px_0px_0px_#046bd2,4px_4px_0px_1px_#000] hover:shadow-[4px_4px_0px_0px_#fff,4px_4px_0px_1px_#000]" data-id="element-106">
                  LinkedIn{' '}
                  <Linkedin className="inline-block w-[18px] h-[18px] align-middle ml-2" data-id="element-107" />
                </a>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}